export default __webpack_public_path__ + "static/media/card-background-common.821b9bb0.svg";